export enum LeadPdvQuantityEnum {
  "ONE" = "1",
  "TWOTOFIVE" = "2 a 5",
  "TWOTOTEN" = "2 a 10",
  "SIXTOTEN" = "6 a 10",
  "MORETHANTEN" = "Mais de 10",
  "NOT_APPLICABLE" = "Não se Aplica",
}
